(function () {
  'use strict';

  class MPProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mpRecommendationsLoading === 'true' || this.dataset.mpRecommendationsLoaded === 'true') return;
      const url = this.dataset.url;
      if (!url) return;
      this.dataset.mpRecommendationsLoading = 'true';
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const selector = `mp-product-recommendations[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`;
          const replacement = parsed.querySelector(selector);
          if (!replacement) throw new Error('Recommendation section response missing expected container');
          this.innerHTML = replacement.innerHTML;
          this.dataset.mpRecommendationsLoaded = 'true';
          this.removeAttribute('aria-busy');
        })
        .catch(() => {
          this.querySelector('[data-mp-recommendations-manual]')?.removeAttribute('hidden');
          const failure = this.querySelector('[data-mp-recommendations-failure]');
          if (failure) failure.hidden = false;
          this.removeAttribute('aria-busy');
        })
        .finally(() => {
          delete this.dataset.mpRecommendationsLoading;
        });
    }
  }

  if (!customElements.get('mp-product-recommendations')) {
    customElements.define('mp-product-recommendations', MPProductRecommendations);
  }
})();
